export { default } from './EditCompositionLyrics';
